import CreationToolGradient from '../../../types/gradient'
import SuperCutSegmentationType from '../../../types/super-cut-segmentation-type'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { UploadFieldBlock } from '../../blocks'
import SegmentedControl from '../../segmented-control'

import Title from './field-title'

type Props = {
    className?: string
    field: CreationToolSuperCutField
    defaultSegmentationType?: SuperCutSegmentationType
    gradient?: CreationToolGradient
    hasCaptionsFile: boolean
    onChange: (segmentationType: SuperCutSegmentationType) => void
}

const CreationCaptureSegmentationTypeField = ({
    className,
    field,
    defaultSegmentationType = SuperCutSegmentationType.Scene,
    hasCaptionsFile = false,
    onChange,
}: Props) => {
    const segmentationTypes = SuperCutSegmentationType.all(hasCaptionsFile)

    const onSegmentationChange = (index: number) => {
        onChange(segmentationTypes[index])
    }

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <SegmentedControl
                {...{
                    defaultIndex: segmentationTypes.indexOf(defaultSegmentationType),
                    items: segmentationTypes.map(SuperCutSegmentationType.title),
                    onIndexChange: (idx) => onSegmentationChange(idx),
                }}
            />
        </UploadFieldBlock>
    )
}

export default CreationCaptureSegmentationTypeField
